import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';

interface ImageWithFallbackProps {
  src?: string;
  alt?: string;
  fallback?: React.ReactNode;
  className?: string;
}

const DefaultFallback: React.FC = () => (
  <div className="flex items-center justify-center size-full bg-gray-100 text-gray-400 rounded-2xl">
    <ImageIcon className="w-6 h-6" />
  </div>
);

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt = 'Image',
  fallback,
  className = 'size-full object-contain',
}) => {
  const [error, setError] = useState(false);

  return error || !src ? (
    <>{fallback ?? <DefaultFallback />}</>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
    />
  );
};

export default ImageWithFallback;
